import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  TemplateRef,
  ViewChild
} from '@angular/core'
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, NonNullableFormBuilder} from "@angular/forms";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {Backend} from "@generated-backend-types";
import Attachment = Backend.App.Http.Resources.Dashboard.Attachment;
import {CoreModule} from "../../../../core.module";
import {FileManagerComponent} from "../../file-manager/file-manager.component";

@Component({
    selector: 'app-attachments-card',
    templateUrl: './attachments-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AttachmentsCardComponent),
            multi: true
        }
    ],
    imports: [CoreModule, FileManagerComponent],
    standalone: true
})
export class AttachmentsCardComponent implements ControlValueAccessor{
  @Input() public formControl: FormControl<Attachment[] | null> = this.fb.control([]);
  @ViewChild('bsModalRefTemplateRef') public bsModalRefTemplateRef!: TemplateRef<BsModalRef>;

  public modalRef?: BsModalRef<unknown>;

  openModal(): void {
    this.modalRef = this.modalService.show(this.bsModalRefTemplateRef,
      {
        ignoreBackdropClick: true,
        keyboard: true,
        backdrop: true,
        class: 'modal-fullscreen bg-transparent p-4 z-'
      }
    )
  }

  public openFile(a: Attachment): void {
    if (a.url) {
      window.open(a.url)
    }

  }
  public remove(a: Attachment): void {

    const index = this.formControl.value?.findIndex(att => att.id === a.id)
    if(index !== undefined && index >= 0) {
      this.formControl.value?.splice(index, 1);
    }


  }

  public attachmentsSelected(event: Attachment[]) {
    const val = this.formControl.value ?? [];
    event.forEach(a => {
      // prevent duplicates
      if (val.findIndex(att => att.id === a.id) < 0) {
        val.push(a)
      }
    })
    this.formControl.patchValue(val)
    this.modalRef?.hide();
  }


  get value(): Attachment[] | null {
    return this.formControl.getRawValue();
  }

  onTouched = () => {
    //
  };

  public registerOnChange(fn: () => void): void {
    this.formControl.registerOnChange(fn)
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if(isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  public writeValue(value: Attachment[] | null): void {
    this.formControl.setValue(value);

  }


  public constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly modalService: BsModalService,
    private readonly fb: NonNullableFormBuilder
  ) {

  }
}
